import styled from "styled-components";

const StyledButton = styled.button`
	width: 100%;
	cursor: pointer;
	border: none;
	border-radius: 100px;
	height: 40px;
	position: relative;
	min-width: 220px;
	transition: transform 0.3s ease-in-out;
	padding: 4px 16px;
	&:hover {
		transform: scale(1.02);
	}

	.ant-spin {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 16px;
	}

	.sb-button {
		&__inner {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 12px;
			white-space: nowrap;

			svg,
			p {
				margin: 0;
			}

			&--uppercase {
				text-transform: uppercase;
			}

			&--disabled {
				opacity: 0.8;
				cursor: not-allowed;
			}

			&__chevron-right {
				width: 40px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				background-color: ${({ theme }) => theme.colors.shark};
				position: absolute;
				top: 5px;
				right: 5px;

				> * {
					color: ${({ theme }) => theme.colors.white};
				}
			}

			&__chevron-left {
				width: 40px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				background-color: ${({ theme }) => theme.colors.shark};
				position: absolute;
				top: 5px;
				left: 5px;
				> * {
					color: ${({ theme }) => theme.colors.white};
				}
			}
		}
	}

	&.disabled {
		opacity: 0.8;
		cursor: not-allowed;
	}

	&.primary-filled {
		background-color: ${({ theme }) => theme.colors.black};
		border: 2px solid transparent;
		.sb-button__inner {
			font-size: 16px;
			color: ${({ theme }) => theme.colors.white};

			> * {
				color: ${({ theme }) => theme.colors.white};
			}
		}

		&--branding-primary-color {
			background-color: ${({ theme }) => theme.colors.coral};

			&--white {
				background-color: ${({ theme }) => theme.colors.coral};
				color: ${({ theme }) => theme.colors.white};
			}
		}
	}

	&.primary-outlined-color {
		background-color: ${({ theme }) => theme.colors.white};
		border: 2px solid ${({ theme }) => theme.colors.coral};
		color: ${({ theme }) => theme.colors.coral};

		.sb-button__inner {
			color: ${({ theme }) => theme.colors.coral};
			font-size: 16px;

			> * {
				color: ${({ theme }) => theme.colors.white};
			}
		}

		&--branding-primary-color {
			background-color: ${({ theme }) => theme.colors.coral};
		}
	}

	&.primary-outlined {
		background-color: ${({ theme }) => theme.colors.white};
		border: 2px solid ${({ theme }) => theme.colors.black};
		white-space: nowrap;

		.sb-button__inner {
			color: ${({ theme }) => theme.colors.black};
			font-size: 16px;
			> * {
				color: ${({ theme }) => theme.colors.black};
			}

			&__chevron-right {
				top: 3px;
				right: 4px;
			}

			&__chevron-left {
				top: 3px;
				left: 4px;
			}
		}

		&:hover {
			border-color: ${({ theme }) => theme.colors.coral};
			.sb-button__inner {
				color: ${({ theme }) => theme.colors.coral};

				> * {
					color: ${({ theme }) => theme.colors.coral};
				}
			}
		}

		&--delete {
			border: 2px solid ${({ theme }) => theme.colors.burntSienna};

			.sb-button__inner {
				font-size: 16px;
				color: ${({ theme }) => theme.colors.burntSienna};

				> * {
					color: ${({ theme }) => theme.colors.burntSienna};
				}
			}

			&:hover {
				background-color: #f9dcdc;
				border-color: #d64f4f;

				.sb-button__inner {
					color: #d64f4f;

					> * {
						color: #d64f4f;
					}
				}
			}
		}
	}
`;

export default StyledButton;
